var exports = {
  "wrapper": "x31de4314--fa2178--wrapper",
  "container": "x31de4314--fa2178--container",
  "close": "x31de4314--fa2178--close",
  "header": "x31de4314--fa2178--header",
  "text": "x31de4314--fa2178--text",
};

module.exports = exports;
